<body>
  <h1>Token Claims</h1>
  
  <div id="access_token_panel" class="panel panel-default">
    <div class="card mb-3">
      <div class="card-body">
        <h2>Access Token</h2>
        <br/>
        <table id="access_token_table" style="width:100%">
          <thead>
            <tr>
              <th>Claim</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of accessToken | keyvalue">
              <td>{{item.key}}</td>
              <td>{{printClaimValue(item)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="col-md-9">
    <router-outlet></router-outlet>
  </div>
</body>